import { render } from "./systemDown.vue?vue&type=template&id=0298933a&scoped=true"
import script from "./systemDown.vue?vue&type=script&lang=js"
export * from "./systemDown.vue?vue&type=script&lang=js"

import "./systemDown.vue?vue&type=style&index=0&id=0298933a&scoped=true&lang=css"

import exportComponent from "E:\\工作\\校闪招\\code\\admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0298933a"]])

export default __exports__